/**
 * searchEmployeeApi.js
 * --------------------
 * API client for Search Employee / Staff Directory module.
 * Connects directly to FastAPI endpoint /self-service/directory/ adhering to Rule 90.
 */
import api from '../../../../api/client';

export const BRANCH_OPTIONS = [
  { value: 'All', label: 'All Branches' },
  { value: 'Mumbai HQ', label: 'Mumbai HQ' },
  { value: 'Bangalore Hub', label: 'Bangalore Hub' },
  { value: 'Pune Tech Node', label: 'Pune Tech Node' },
];

export const DEPARTMENT_OPTIONS = [
  { value: 'All', label: 'All Departments' },
  { value: 'Engineering & DevOps', label: 'Engineering & DevOps' },
  { value: 'Product Development', label: 'Product Development' },
  { value: 'UI/UX & Design', label: 'UI/UX & Design' },
  { value: 'QA & Compliance', label: 'QA & Compliance' },
  { value: 'Operations & Facilities', label: 'Operations & Facilities' },
  { value: 'Human Resources', label: 'Human Resources' },
  { value: 'Finance & Accounts', label: 'Finance & Accounts' },
];

export const searchEmployeeApi = {
  getList: async (params = {}) => {
    try {
      const response = await api.get('/self-service/directory/', { params });
      return {
        data: response.data.data || [],
        total: response.data.total || (response.data.data || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch employee directory from server:', err);
      return { data: [], total: 0 };
    }
  },
};
